import Immutable, { Immutable as ImmutableGenericType } from 'seamless-immutable'

export interface Pop {
  maxDocuments?: number
}

export type PopState = ImmutableGenericType<Pop>

export const initialState: PopState = Immutable({
  maxDocuments: undefined,
})
